// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesModal-cls1_r1g","cls2":"SavedReferencesModal-cls2_kb7 SavedReferencesModal-cls1_r1g"};